// regions

// staging
export const REGION_US_WEST_2_VALUE = "us-west-2";
export const REGION_US_WEST_2_NAME = "US West (Oregon)";

// production
export const REGION_US_EAST_1_VALUE = "us-east-1";
export const REGION_US_EAST_1_NAME = "US East (N. Virginia)";

export const REGION_SA_1_VALUE = "sa-east-1";
export const REGION_SA_1_NAME = "South America (São Paulo)";

// feature flags

export const FEATURE_FLAG_CONNECTIONS_TYPE = "connections";
export const FEATURE_FLAG_MAGIC_LOGIN_LINKS_TYPE = "magic-login-links";
export const FEATURE_FLAG_STANDBY_INSTANCES_TYPE = "standby-instances";
export const FEATURE_FLAG_METABASE_AI_TYPE = "metabase-ai-tiered";
const FEATURE_FLAG_ENABLE_TRIAL_DWH_TYPE = "enable-trial-dwh";
export const FEATURE_FLAG_FREE_METABASE_AI_TYPE = "metabase-ai-free";
export const FEATURE_FLAG_OFFER_METABASE_AI_MANAGED_TYPE =
  "offer-metabase-ai-managed";
export const FEATURE_FLAG_OFFER_TRANSFORMS_TYPE = "offer-transforms";
export const FEATURE_FLAG_OFFER_METERED_TRANSFORMS_TYPE =
  "offer-metered-transforms";
export const FEATURE_FLAG_INCLUDE_DWH_RENT_TYPE =
  "include-dwh-rent-in-cloud-checkouts";
export const FEATURE_FLAG_OFFER_PRODUCT_ANALYTICS_TYPE =
  "offer-product-analytics";
export const FEATURE_FLAG_OFFER_IP_ALLOWLIST_TYPE = "offer-ip-allowlist";

export const FEATURE_FLAGS_TYPES = [
  "allow-throttle-mb-emails",
  FEATURE_FLAG_CONNECTIONS_TYPE,
  "self-service-invoicing",
  "kill-hosting-single-tenant",
  "kill-clickhouse-dwh",
  "kill-eu-central-1-region",
  "new-prods",
  "kill-stripe-user-count-sync",
  "custom-image-tracking-enabled",
  "kill-hosting-multi-tenant",
  "scheduled-maintenance-enabled",
  "kill-stripe-subscription-sync",
  "allow-enterprise-contracts-jobs",
  "kill-non-stripe-subscription-sync",
  "multi-product-subscriptions",
  "allow-create-snapshot-errors",
  "support-users",
  "elt-sync",
  "dwh",
  FEATURE_FLAG_MAGIC_LOGIN_LINKS_TYPE,
  FEATURE_FLAG_STANDBY_INSTANCES_TYPE,
  FEATURE_FLAG_ENABLE_TRIAL_DWH_TYPE,
  FEATURE_FLAG_METABASE_AI_TYPE,
  FEATURE_FLAG_FREE_METABASE_AI_TYPE,
  FEATURE_FLAG_OFFER_METABASE_AI_MANAGED_TYPE,
  FEATURE_FLAG_OFFER_TRANSFORMS_TYPE,
  FEATURE_FLAG_OFFER_METERED_TRANSFORMS_TYPE,
  FEATURE_FLAG_INCLUDE_DWH_RENT_TYPE,
  FEATURE_FLAG_OFFER_PRODUCT_ANALYTICS_TYPE,
  FEATURE_FLAG_OFFER_IP_ALLOWLIST_TYPE,
] as const;
